import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import httpClient from '@/lib/httpClient';
import type { DefaultQueryError } from '../types';
import type { EstimateFeeParams, EstimateFeeData } from './types';

export const useEstimateFeeFn = async (body: EstimateFeeParams) => {
  const response = await httpClient.post<EstimateFeeData[]>(
    apiRoutes.services.estimate_fee,
    body,
    { headers: { Lang: body.lang || 'vi' } }
  );
  return response.data;
};

export const useEstimateFeeMutation = (
  opts?: UseMutationOptions<
    EstimateFeeData[],
    DefaultQueryError,
    EstimateFeeParams
  >
) =>
  useMutation<EstimateFeeData[], DefaultQueryError, EstimateFeeParams>(
    useEstimateFeeFn,
    opts
  );
